import styles from '../styles.module.css';

function MeetingSession({ name, count, selected, onClick }) {
  
  return (
    <div className={styles['meeting-session']} onClick={onClick}>
      <a className={`${ selected ? styles['selected-session'] : ''}`}>
        {name} {`(${count})`}
      </a>
    </div>
  )
}

export default MeetingSession;